<template>
  <div class="tabulka half">
    <div class="tabulka__top">
      <input
        type="text"
        class="tabulka__top__input"
        v-model="name"
        :class="{ visible: renamingTeam }"
      />
      <div class="tabulka__top__nadpis" :class="{ notVisible: renamingTeam }">
        {{ name }}
      </div>
      <!--      <button-->
      <!--        class="tabulka__top__button rename"-->
      <!--        @click="renameTeam()"-->
      <!--        :class="{'renaming':renamingTeam}"-->
      <!--      >Rename-->
      <!--      </button>-->
      <button
        class="tabulka__top__button delete"
        @click="$emit('delete')"
        :class="{ renaming: renamingTeam }"
      >
        Delete
      </button>
    </div>

    <div class="tabulka__body">
      <table>
        <thead>
          <td>
            <span>Player</span>
            <SortButton
              row="username"
              type="a"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
          </td>
          <td>
            <span>Email</span>
            <SortButton
              row="email"
              type="a"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
          </td>
          <td>
            <div
              class="tabulka__body__togglebutton"
              v-on:click="gamesVisible = !gamesVisible"
              :class="{ opened: gamesVisible }"
            >
              <div class="tabulka__body__togglebutton__arrow">
                <div class="tabulka__body__togglebutton__arrow__img"></div>
              </div>
            </div>
          </td>
        </thead>
        <tr v-for="player in resultData" :key="player.id">
          <td class="gray">
            <div class="tabulka__body__userProfileIcon"></div>
            {{ player.username }}
          </td>
          <td class="gray">{{ player.email }}</td>
          <!--          <td class="right">-->
          <!--            <button-->
          <!--              @click="$emit('kick-player', player)"-->
          <!--              class="tabulka__body__removeButton"-->
          <!--              style="margin-left: 15px"-->
          <!--            >Kick</button>-->
          <!--            <button-->
          <!--              @click="$emit('delete-player', player)"-->
          <!--              class="tabulka__body__removeButton"-->
          <!--            >Remove</button>-->
          <!--          </td>-->
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import SortButton from "@/components/game/table/SortButton.vue";
import sortingLogicMixin from "@/components/game/table/sortingLogicMixin.js"; // obsahuje logiku k sortovani
import _ from "lodash";

export default {
  name: "TeamPlayers",
  mixins: [sortingLogicMixin],
  components: {
    SortButton,
  },
  props: {
    sourceData: Array,
    name: String,
  },
  data() {
    return {
      currentSortRow: "username",
      gamesVisible: true,
      renamingTeam: false,
    };
  },
  computed: {
    resultData() {
      if (this.gamesVisible == true) {
        return _.uniqBy(this.sortedData, "id");
      } else {
        return null;
      }
    },
  },
};
</script>
